import { SET_DATE_RANGE } from './../../constants/ActionTypes';

export const setDateRange = (dateRange) => {
  return (dispatch) => {
    dispatch({
      type: SET_DATE_RANGE,
      payload: dateRange,
    });
  };
}

